module.exports = __webpack_public_path__ + "img/mainInbound.2f05a858.png";